import { render } from "./VerCodigoParceiroModal.vue?vue&type=template&id=5d5a50b9&scoped=true"
import script from "./VerCodigoParceiroModal.vue?vue&type=script&lang=js"
export * from "./VerCodigoParceiroModal.vue?vue&type=script&lang=js"

import "./VerCodigoParceiroModal.vue?vue&type=style&index=0&id=5d5a50b9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5a50b9"]])

export default __exports__